// SIRET is a 14-digit French establishment identifier, typically displayed
// grouped as "XXX XXX XXX XXXXX". The create-organisation form auto-formats on
// blur, so we keep spaces in the live input but reject letters, punctuation
// and any digits past the 14-digit cap as the user types.
export const SIRET_DIGIT_COUNT = 14;
// La Poste's SIREN (first 9 digits of every La Poste SIRET). INSEE exempts these
// SIRETs from the Luhn checksum and instead requires the sum of all 14 digits
// to be a multiple of 5.
const LA_POSTE_SIREN_PREFIX = "356000000";
export function sanitizeSiretInput(raw) {
    let digitCount = 0;
    let sanitized = "";
    for (const ch of raw) {
        if (ch >= "0" && ch <= "9") {
            if (digitCount < SIRET_DIGIT_COUNT) {
                sanitized += ch;
                digitCount++;
            }
        }
        else if (ch === " ") {
            sanitized += ch;
        }
    }
    return sanitized;
}
// Validates a 14-digit SIRET against the INSEE checksum rules. Spaces are
// tolerated so the live, on-blur-grouped form value can be passed in directly.
// An empty string returns false — callers that treat SIRET as optional must
// check emptiness themselves before calling this.
export function isValidSiret(raw) {
    const digits = raw.replace(/\s/g, "");
    if (digits.length !== SIRET_DIGIT_COUNT || !/^\d{14}$/.test(digits)) {
        return false;
    }
    if (digits.startsWith(LA_POSTE_SIREN_PREFIX)) {
        let sum = 0;
        for (let i = 0; i < SIRET_DIGIT_COUNT; i++)
            sum += Number(digits[i]);
        return sum % 5 === 0;
    }
    // Standard Luhn: from the rightmost digit, every second digit is doubled
    // (positions 2, 4, … from the right). On a 14-digit string indexed from the
    // left that maps to even indices 0, 2, 4, … 12.
    let sum = 0;
    for (let i = 0; i < SIRET_DIGIT_COUNT; i++) {
        let digit = Number(digits[i]);
        if (i % 2 === 0) {
            digit *= 2;
            if (digit > 9)
                digit -= 9;
        }
        sum += digit;
    }
    return sum % 10 === 0;
}
